"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocationFromGeocodingSearchResult = getLocationFromGeocodingSearchResult;
function isPositionCorrect(position) {
  if (!position) {
    return false;
  }
  const {
    latitude,
    longitude
  } = position;
  if (latitude > 90 || latitude < -90 || longitude > 180 || longitude < -180) {
    return false;
  }
  return true;
}
function getLocationFromGeocodingSearchResult(result) {
  const {
    results = []
  } = result ?? {};
  const {
    position
  } = results[0] ?? {};
  const location = isPositionCorrect(position) ? position : undefined;
  return location;
}